import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    userHasPaymentMethods: false,
});


const userSettings = (state = initState(), action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case DispatchConstants.BILLING_USER_SETTINGS_INIT:
            return initState();
        case DispatchConstants.BILLING_USER_SETTINGS_SET_USER_HAS_METHODS:
            return {
                ...state,
                userHasPaymentMethods: payload,
            };
        default:
            return state;
    }
};

export default userSettings;
